import Swiper from 'swiper/bundle';
document.addEventListener("DOMContentLoaded", function () {
    const sliderColumns = document.querySelectorAll('.wp-block-columns.is-style-slider-mobile');

    sliderColumns.forEach(function (element) {
        if (!element.parentElement.classList.contains('swiper')) {
            element.classList.add('swiper-wrapper');

            const swiperWrapper = document.createElement('div');
            swiperWrapper.classList.add('swiper');
            swiperWrapper.classList.add('ouw-columns-swiper');
            element.parentNode.insertBefore(swiperWrapper, element);
            swiperWrapper.appendChild(element);
            const swiperPagination = document.createElement('div');
            swiperPagination.classList.add('swiper-pagination');
            swiperWrapper.appendChild(swiperPagination);
        }
    });

    const swiper = new Swiper('.ouw-columns-swiper', {
        loop: false,
        spaceBetween: 0,
        slideClass: 'wp-block-column',
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: true
        },
        autoplay: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                noSwiping: false,
            },
            782: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                noSwiping: true,
                noSwipingClass: 'ouw-columns-swiper',
            }
        }
    });
});